import { Spinner } from '@optiaxiom/react';
import { DataTableExpandableCell, DataTableExpandableHeader } from '@optiaxiom/react/unstable';
import { createColumnHelper } from '@tanstack/react-table';

import { ActivityStatusCell, ChatEnabledStatusCell, NameCell } from './cells';
import { ToolsTableRow } from './types';

const columnHelper = createColumnHelper<ToolsTableRow>();

type ColumnsProps = {
  isUpdating: boolean;
  updatingToolId: string | null | undefined;
  isUpdatingEnabledInPrimaryAgent: boolean;
  updatingToolIdEnabledInPrimaryAgent: string | null | undefined;
  onToggleActive: (toolId: string, isDisabled: boolean) => void;
  onToggleEnabledInPrimaryAgent: (toolName: string, isEnabledInPrimaryAgent: boolean) => void;
};

const createColumns = ({
  isUpdating,
  updatingToolId,
  isUpdatingEnabledInPrimaryAgent,
  updatingToolIdEnabledInPrimaryAgent,
  onToggleActive,
  onToggleEnabledInPrimaryAgent,
}: ColumnsProps) => [
  columnHelper.accessor('name', {
    header: () => <DataTableExpandableHeader>Name</DataTableExpandableHeader>,
    cell: props => (
      <DataTableExpandableCell {...props}>
        <NameCell toolRow={props.row.original} />
      </DataTableExpandableCell>
    ),
    size: 400,
  }),
  columnHelper.accessor('auth_status', {
    header: 'Auth Status',
    cell: ({ row }) => {
      if (row.original.isRegistry) return null;

      const toolRow = row.original;
      return toolRow.tool.auth_status
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
  }),
  columnHelper.display({
    id: 'active',
    header: 'Active',
    cell: ({ row }) => {
      if (row.original.isRegistry) return null;

      const toolRow = row.original;
      const isLoading =
        (isUpdating && updatingToolId === toolRow.tool.function_id) ||
        (isUpdatingEnabledInPrimaryAgent &&
          updatingToolIdEnabledInPrimaryAgent === toolRow.tool.function_id);

      if (isLoading) {
        return <Spinner size="xs" />;
      }

      return <ActivityStatusCell tool={toolRow.tool} onToggleActive={onToggleActive} />;
    },
  }),
  columnHelper.display({
    id: 'enabled_in_chat',
    header: 'Enabled in Chat',
    cell: ({ row }) => (
      <ChatEnabledStatusCell
        toolRow={row.original}
        onToggleEnabledInPrimaryAgent={onToggleEnabledInPrimaryAgent}
      />
    ),
  }),
];

export default createColumns;
